module.exports = __webpack_public_path__ + "static/media/altair.ddbeeb7f.png";